export default __webpack_public_path__ + "static/media/about-vid-1.2181d4a0.mp4";